import React from "react";
import FeedbackPage from "./components/FeedbackPage";

function App() {
  return (
    <FeedbackPage />
  );
}

export default App;
